import './bootstrap.js';
import './contact.js';
import './invite.js';
import './careers.js';

if(top.location !== location) {
    top.location.href = document.location.href;
}

$(document).ready(function() {
    $('[data-toggle="tooltip"]').tooltip();

    //if signup has data-show enabled show it.
    if($('#signup-modal').attr('data-show')){
        $('#signup-modal').modal();
    }

    $('.dropdown-submenu a.submenu-link').on("mouseenter", function(e){
        $(this).next('ul').toggle();
        e.stopPropagation();
        e.preventDefault();
    });

    /* ======= Header Background Slideshow - Flexslider ======= */
    /* Ref: https://github.com/woothemes/FlexSlider/wiki/FlexSlider-Properties */

    $('#bg-slider').flexslider({
        animation: "fade",
        directionNav: false, //remove the default direction-nav (< >)
        controlNav: false, //remove the default control-nav (o o o)
        slideshowSpeed: 6000
    });


    /* ======= FAQ accordion ======= */
    function toggleIcon(e) {
        $(e.target)
            .prev('.panel-heading')
            .find('.panel-title a')
            .toggleClass('active')
            .find("i.fa")
            .toggleClass('fa-plus-square fa-minus-square');
    }
    $('.panel').on('hidden.bs.collapse', toggleIcon);
    $('.panel').on('shown.bs.collapse', toggleIcon);

    /* ======= Fixed header when scrolled ======= */
    $(window).bind('scroll', function() {
        if ($(window).scrollTop() > 0) {
            $('#header').addClass('navbar-fixed-top');
        }
        else {
            $('#header').removeClass('navbar-fixed-top');
        }
    });
});
